import { Operator, appstraxUsers } from '@appstrax/services/auth';

export async function lookupUserEmails(
  userIds: string[],
  cache: Record<string, string>
): Promise<Record<string, string>> {
  const ids = Array.from(new Set((userIds ?? []).map((value) => String(value ?? '').trim()).filter(Boolean)));
  if (!ids.length) return cache;

  const missing = ids.filter((id) => !cache[id]);
  if (!missing.length) return cache;

  try {
    const res: any = await appstraxUsers.find({ where: { id: { [Operator.IN]: missing } } as any });
    const next = { ...cache };
    for (const user of (res?.data ?? []) as any[]) {
      const id = String(user?.id ?? '').trim();
      const email = String(user?.email ?? '').trim();
      if (id && email) next[id] = email;
    }
    return next;
  } catch {
    // Fall back to per-user lookups below.
  }

  const next = { ...cache };
  for (const id of missing) {
    try {
      const res: any = await appstraxUsers.find({ where: { id } as any, limit: 1 });
      const user = (res?.data ?? [])[0] ?? null;
      const email = String(user?.email ?? '').trim();
      if (email) next[id] = email;
    } catch {
      // Ignore lookup failures and keep the userId fallback.
    }
  }
  return next;
}
